
import { MapRef } from 'react-map-gl/maplibre';
import { MutableRefObject} from 'react'
import { Board, Place, PlaceGroup } from '../utils/Primitives';
import { getPlace, getPlaces } from './Places'
import { renderLayerForSlap } from '../slaps/DisplaySlaps'
import { SortLayers } from '../map/SortLayers'
import { BlockPlaces } from '@ivyroot/block-places';


export const commitButtonSourceIdForPlace = (placeId: number) => {
    return `place-commit-btn-src-${placeId}`
}

export const commitButtonLayerIdForPlace = (placeId: number) => {
    return `place-commit-btn-lyr-${placeId}`
}

export const undoButtonSourceIdForPlace = (placeId: number) => {
    return `place-undo-btn-src-${placeId}`
}

export const undoButtonLayerIdForPlace = (placeId: number) => {
    return `place-undo-btn-lyr-${placeId}`
}

export const renderVisiblePlaces = (params:  {
    mapRef?: MutableRefObject<MapRef | null>
    boardRef: MutableRefObject<Board>,
}) => {
    const { mapRef, boardRef } = params
    if (!mapRef) {
        return;
    }
    if (!mapRef.current) {
        return;
    }
    const map = mapRef.current.getMap();
    if (!map) {
        return;
    }
    if (map.getZoom() < 8) {
        console.log(`skipping render of places because zoom is high`)
        return;
    }
    const bounds = map.getBounds();
    const visiblePlaceIds = BlockPlaces.getPlaceIdsInBounds(bounds)
    const visiblePlaceGroup = {} as PlaceGroup;
    for (const i in visiblePlaceIds) {
        const placeId = visiblePlaceIds[i]
        if (placeId) {
            visiblePlaceGroup[placeId] = {id: placeId} as Place
        }
    }
    const foundPlaces = getPlaces({boardRef, places: visiblePlaceGroup})
    for (const placeId in foundPlaces) {
        const currPlace = foundPlaces[placeId]
        if (currPlace && currPlace.bounds) {
            renderLayerForPlace({
                boardRef,
                mapRef: mapRef,
                placeId: currPlace.id,
            })
        }
    }
    SortLayers({mapRef, boardRef})
}

export const renderLayerForPlace = (props: {
    placeId: number;
    mapRef?: MutableRefObject<MapRef | null>
    boardRef: MutableRefObject<Board>,
}) => {
    const { boardRef, mapRef,  placeId } = props
    if (!mapRef) {
        return;
    }
    if (!mapRef.current) {
        return;
    }
    const map = mapRef.current.getMap();
    if (!map) {
        return;
    }
    const place = getPlace({boardRef, placeId})
    if (!place) {
        return
    }
    if (place.slap) {
        renderLayerForSlap({ mapRef, boardRef, slapId: place.slap })
    }
    if (place.pendingSlaps) {
        for (const pendingSlapId of place.pendingSlaps) {
            if (pendingSlapId !== undefined && pendingSlapId !== null) {
                renderLayerForSlap({ mapRef, boardRef, slapId: pendingSlapId })
            }
        }
    }
}
